module.exports = __webpack_public_path__ + "img/note_refund.8ebaa83d.png";